jQuery(document).ready(function($) {
	/* Mobile Menu */
	mobileNavigationMenuSelector = ".mobile-navigation-menu"
	menu = new Mmenu(mobileNavigationMenuSelector, {
		extensions: [
			"position-right"
		],
		navbar: {
			add: true,
			title: ""
		},
		screenReader: {
			aria: true,
			text: true
		}
	}, {
		classNames: {
			selected: "active"
		},
		offCanvas: {
			page: {
				selector: "#page"
			}
		}
	});

	api = menu.API;
	$(".mobile-menu-button").click(function() {
		if ($(mobileNavigationMenuSelector).hasClass("mm-menu_opened")) {
			api.close();
		}
		else {
			api.open();
		}

		calculateMobileMenuMargin();
	});

	/* Accessible menu */
	if (navigator.userAgent.match(/iPad/i) != null) {
		$(".button-link  .text-block-3").click(function(event) {
			if (!$(this).parents(".hasChildren").hasClass("open")) {
				$(".button-link ").removeClass("open");
				event.preventDefault();
				$(this).parent(".hasChildren").addClass("open");
			}
		});
	}
	else {
		$(".text-block-3").hover(function() {
			$(this).addClass("open");
		}, function() {
			$(this).removeClass("open");
		});
	}
	$(".accesible-navigation-menu").accessibleMenu();

	/* Search */
	$(".show-search").on("click", function() {
		$("body").addClass('open-search');
	});

	$(".hide-search").on("click", function() {
		$("body").removeClass('open-search');
	});


	/* Alerts */
	function setCookie(cname, cvalue) {
		document.cookie = cname + "=" + cvalue + ";path=/";
	}

	function getCookie(cname) {
		var match = document.cookie.match(new RegExp("(^| )" + cname + "=([^;]+)"));

		return match ? match[2] : null;
	}

	/* Popup alert: shown on first access, then again on a later page if 5 minutes have
	   passed since it was first closed. Not shown again after being closed a second time. */

	$( ".close-popup-alert" ).click(function() {
		$(".popup-alert").hide();
		if ( !getCookie("popupAlertClosedAt") ) {
			setCookie("popupAlertClosedAt", Date.now());
		}
	});

	var popupAlertShown = parseInt(getCookie("popupAlertShown"), 10) || 0;

	if (popupAlertShown < 1) {
		$(".popup-alert").show();
		setCookie("popupAlertShown", "1");
	}
	else if (popupAlertShown === 1) {
		var popupAlertClosedAt = parseInt(getCookie("popupAlertClosedAt"), 10);

		if (popupAlertClosedAt && (Date.now() - popupAlertClosedAt) >= (20 * 60 * 1000)) {
			$(".popup-alert").show();
			setCookie("popupAlertShown", "2");
		}
	}

	$( ".close-scroll-alert" ).click(function() {
		$(".scroll-alert").hide();
		setCookie("scrollAlert", "isShown");
	});

	if ( document.cookie.indexOf("scrollAlert=") == -1 ) {
		$(".scroll-alert").show();
		initMarquee();
	}

	/* Scroll alert marquee: repeats the content until one set fills the banner, then doubles that
	   set so the track can loop seamlessly at -50%. Duration is derived from the set width so the
	   scrolling speed stays the same regardless of how much text there is. */
	function initMarquee() {
		var marqueeSpeed = 120, /* pixels per second */
			$wrapper = $(".scroll-alert .marquee-wrapper"),
			$track = $wrapper.find(".marquee-track"),
			$original = $("#scroll-alert-marguee-content"),
			blnIntroPlayed = false,
			strLastSize = "",
			resizeTimer;

		if ( !$original.length ) {
			return;
		}

		function buildMarquee() {
			/* getBoundingClientRect keeps sub-pixel precision (offsetWidth rounds); translateX doesn't affect width */
			var itemWidth = $original[0].getBoundingClientRect().width,
				wrapperWidth = $wrapper.width(),
				strSize = itemWidth + "x" + wrapperWidth;

			/* Skip rebuilding when nothing has changed so a running intro isn't restarted */
			if ( !itemWidth || !wrapperWidth || strSize === strLastSize ) {
				return;
			}

			strLastSize = strSize;
			$track.removeClass("is-ready is-intro").find(".marquee-content").not($original).remove();

			var copiesPerSet = Math.max(1, Math.ceil(wrapperWidth / itemWidth)),
				setWidth = copiesPerSet * itemWidth;

			for (var i = 1; i < copiesPerSet * 2; i++) {
				$original.clone()
					.attr("aria-hidden", "true")
					.appendTo($track)
					.find("a, button, input, select, textarea, [tabindex]").attr("tabindex", "-1");
			}

			$track[0].style.setProperty("--marquee-duration", (setWidth / marqueeSpeed) + "s");

			/* The first time it is shown, slide in from the right edge at the same speed before looping */
			if ( !blnIntroPlayed ) {
				$track[0].style.setProperty("--marquee-intro-offset", wrapperWidth + "px");
				$track[0].style.setProperty("--marquee-intro-duration", (wrapperWidth / marqueeSpeed) + "s");
				$track.addClass("is-intro");
			}

			/* Force a reflow so the animation restarts from the beginning */
			void $track[0].offsetWidth;
			$track.addClass("is-ready");
		}

		$track.on("animationend", function(event) {
			if ( event.originalEvent.animationName === "marquee-intro" ) {
				blnIntroPlayed = true;
			}
		});

		buildMarquee();

		/* Rebuild once web fonts have loaded and whenever the banner width changes */
		$(window).on("load", buildMarquee);
		$(window).on("resize", function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(buildMarquee, 200);
		});
	}

	/* Scroll Down */
	$( ".scroll-down-bt" ).click(function() {
		window.scrollTo({
			top: 300,
			behavior: 'smooth'
		});
	});

	/* Typekit */
	try {
		Typekit.load();
	}
	catch (e) {

	}

	/* Mobile Menu Margin */
	$(window).on('load resize', function() {
		calculateMobileMenuMargin();
	});

	function calculateMobileMenuMargin() {
		if ( $( ".section-container.is--intro" ).length && getVisibleSliderHeight() > 0) {
			mobileMargin = $(".section-container.is--nav").height() + getVisibleSliderHeight();
		}
		else {
			mobileMargin = $(".section-container.is--nav").height();
		}

		$(".mobile-navigation-menu").css("margin-top", mobileMargin);
	}
});

function getVisibleSliderHeight() {
	var $el = $('.section-container.is--intro'),
		scrollTop = $(this).scrollTop(),
		scrollBot = scrollTop + $(this).height(),
		elTop = $el.offset().top,
		elBottom = elTop + $el.outerHeight(),
		visibleTop = elTop < scrollTop ? scrollTop : elTop,
		visibleBottom = elBottom > scrollBot ? scrollBot : elBottom;

	return visibleBottom - visibleTop;
}
